// @flow

import { categorizedFilterPredicate } from '../pills/categorized-filter-predicate';

export const tagFilterPredicate = (filters: $ReadOnlyArray<Object>) =>
  categorizedFilterPredicate(
    (filters || [])
      .filter((f) => f && f.id && f.tagType)
      .map((f) => ({ id: f.id, categoryKey: f.tagType })),
    (location) => (location && location.tags) || [],
  );
